import { MONTH_CODES } from "./constants";

export const formatExpirationDate = (
  pcode: string | undefined,
  term: string | undefined,
  symbol: string | undefined,
): { code: string; date: string } => {
  let cleanCode = pcode || "";
  if (!cleanCode && symbol) {
    cleanCode = symbol.split(" ")[0].replace(/([FGHJKMNQUVXZ])(\d{1,2})$/i, "");
  }

  if (term && term.includes("-")) {
    const parts = term.trim().split("-");

    if (parts.length === 3) {
      const month = parts[0];
      const day = parts[1];
      const shortYear = parts[2].slice(-2);

      return {
        code: cleanCode || symbol || "",
        date: `${day}${month}${shortYear}`,
      };
    }

    if (parts.length === 2) {
      const month = parts[0];
      const shortYear = parts[1].slice(-2);

      return {
        code: cleanCode || symbol || "",
        date: `${month}${shortYear}`,
      };
    }
  }

  if (symbol) {
    const baseSymbol = symbol.split(" ")[0];
    const match = baseSymbol.match(
      /^([a-zA-Z0-9]+?)([FGHJKMNQUVXZ])(\d{1,2})$/i,
    );

    if (match) {
      const [, code, monthCode, year] = match;
      const month = MONTH_CODES[monthCode.toUpperCase()];

      if (month) {
        const currentDecade = new Date().getFullYear().toString().slice(2, 3);
        const formattedYear =
          year.length === 1 ? `${currentDecade}${year}` : year;
        return { code: pcode || code, date: `${month}${formattedYear}` };
      }
    }
  }

  return { code: cleanCode || symbol || "", date: "" };
};
